export default {
    name: 'FrequentlyAskedQuestions'
}
